export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/discount.f24fa6fe.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};